/**
 * Suppress webpack dev server overlay for non-Error unhandled rejections,
 * and suppress known legacy React warnings from third-party libraries.
 * 
 * This must be loaded as a webpack entry point BEFORE the app code.
 */
if (process.env.NODE_ENV === 'development') {
    // Suppress [object Object] overlay from API rejections
    window.addEventListener('unhandledrejection', function(event) {
        if (event.reason && !(event.reason instanceof Error)) {
            event.preventDefault();
            console.warn('Suppressed non-Error promise rejection:', event.reason);
        }
    });

    // Suppress known legacy context API warnings from react-router@3 and react-bootstrap
    const originalError = console.error;
    console.error = function(...args) {
        const msg = typeof args[0] === 'string' ? args[0] : '';
        // Suppress legacy childContextTypes/contextTypes warnings from third-party libs
        if (msg.includes('uses the legacy childContextTypes API') ||
            msg.includes('uses the legacy contextTypes API')) {
            return;
        }
        originalError.apply(console, args);
    };
}
